<script setup>
/* eslint-disable */
import { ref, watch } from "vue"
import { useOddsStore } from '@/stores/odds';
import { BetSlip } from '@/stores/BetSlip';
import { EditBetSlip } from "@/stores/edit_betslip";
import menuIcons from '@/assets/svgs/NotificationMenu.json'
import commonSvgs from '@/assets/svgs/commonSvgs.json'

const svg_data = ref(commonSvgs);
const menu_icons = ref(menuIcons);

const oddsStore = useOddsStore();
const betslipStore = BetSlip();
const editBetslipStore = EditBetSlip();
const price_up = ref(false);
const price_down = ref(false);

const props = defineProps({
	overview_market_header_name: {
		type: String,
		required: true,
	},
	overview_odd: {
		// type: Object,
		required: true,
	},
	needs_indicator: {
		type: Boolean,
		required: true,
	},
	fixture_id: {
		required: true,
	}
})

const addToBetslip = () => {
	if (!props.overview_odd || props.overview_odd.status == 'suspended') return;

	if (editBetslipStore.edit_mode_enabled) editBetslipStore.toggleToBetslip({ uuid: props.overview_odd.uuid, fixture_id: props.fixture_id })
	else betslipStore.toggleToBetslip({ odd_uuid: props.overview_odd.uuid, fixture_id: props.fixture_id })
}

watch(() => props.overview_odd, (newOdd, oldOdd) => {
	if (newOdd == null || oldOdd == null) return;

	if (newOdd.status == 'suspended' || oldOdd.status == 'suspended') return;

	// If changed overview market from overview
	if (newOdd.uuid != oldOdd.uuid) return;

	if (newOdd.price > oldOdd.price) price_up.value = true;
	if (newOdd.price < oldOdd.price) price_down.value = true;

	setTimeout(() => {
		price_up.value = false;
		price_down.value = false;
	}, 5000);
})

</script>

<template>
	<div @click="addToBetslip" class="betting-info-inner" :class="{'odd-selected': overview_odd && oddsStore.isOddInBetslip(overview_odd.uuid) }">
		<span v-if="needs_indicator && overview_odd"> {{ props.overview_market_header_name  }} {{ '(' + overview_odd.name_overview   + ') ' }} </span>
		<span v-else> {{ props.overview_market_header_name  }} </span>

		<div class="betting-info-main" :class="{'bet-up': price_up, ' bet-down': price_down}">
			<template v-if="overview_odd && !oddsStore.isOddSuspended(overview_odd)">
				<h6> {{ oddsStore.oddsFormat(overview_odd.price) }} </h6>
			</template>
			<template v-else>
				<h6 v-html="menu_icons.lock"></h6>
			</template>
		</div>
	</div>
</template>
<style scoped>
.betting-info-main {
	box-shadow: 0px 0px 2px rgba(12, 19, 26, 0.4);
}
</style>

